import React from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function BlogEditor({ value, onChange }) {
  return (
    <Editor
      apiKey="6bdkvog0moag8ggey06v96u30gmopxz0t78bp0swz1x36022"
      value={value || ""}
      onEditorChange={(newValue) => onChange(newValue)}
      init={{
        height: 500,
        menubar: true,

        plugins: [
          "anchor",
          "autolink",
          "charmap",
          "codesample",
          "emoticons",
          "image",
          "link",
          "lists",
          "media",
          "searchreplace",
          "table",
          "visualblocks",
          "wordcount",
        ],

        toolbar:
          "undo redo | blocks fontfamily fontsize | " +
          "bold italic underline strikethrough | " +
          "link image media table | align lineheight | " +
          "numlist bullist indent outdent | emoticons charmap | removeformat",

        /* ✅ Image upload (local + server support ready) */
        image_title: true,
        automatic_uploads: true,
        file_picker_types: "image",

        file_picker_callback: (callback) => {
          const input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");

          input.onchange = function () {
            const file = this.files[0];
            const reader = new FileReader();

            reader.onload = function () {
              callback(reader.result, {
                alt: file.name,
              });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
      }}
    />
  );
}
